import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function trainingGroundReducer(state = initialState.trainingGround, action) {
  const trainingGround = { ...state };
  
  switch (action.type) {
    case types.LOAD_TRAINING_GROUND_CONTENT_FEED_SUCCESS: {
      return {
        ...state,
        contentFeed: {
          ...action.content,
          loading: false,
        },
      };
    }
    case types.GET_TRAINING_GROUND_POPULAR_SEARCHES:
      trainingGround.popularSearches = action.data;
      return trainingGround;

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./library/app/reducers/trainingGroundReducer.js